<div class="table-column-header" [ngClass]="'table-column-header--' + verticalBreakpoint">
  <div
    *ngFor="let column of columns"
    class="table-column-header__item"
    [ngClass]="'col-' + column.gridSize"
    [title]="column.headerTitle"
  >
    {{ column.name }}
    <ftr-icon
      *ngIf="column.sort === 'desc'"
      class="table-column-header__item-icon"
      icon="NavigateDown"
      align="Middle"
      color="GreyLight"
      size="Large"
    ></ftr-icon>
    <ftr-icon
      *ngIf="column.sort === 'asc'"
      class="table-column-header__item-icon"
      icon="NavigateUp"
      align="Middle"
      color="Grey"
      size="Large"
    ></ftr-icon>
  </div>
</div>
